/**
 * Created by Administrador on 13/08/2024.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('takeoffCapabilities', {
                parent: 'app',
                url: '/takeoffCapacity?departureDate',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configGeneral/takeoffCapacity/takeoffCapacity.html',
                        controller: 'takeoffCapacityCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['takeoffCapacity']);
                            }]
                        }
                    }
                }
            });
    }
})();
